import IconButton from "@mui/material/Icon";
import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 20px;
`;

export const IconeButton = styled(IconButton)`
    position: 'absolute';
    right: 10px;
    top: 10px;
    color: #111;
`;

export const Title = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
`;

export const Divider = styled.div`
    display: flex;
    justify-content: space-between;

    & .subTitle {
        font-size: 18px;
        font-weight: bold;
        font-family: 'Lato', sans-serif;
    }

    & div{
        font-size: 16px;
        font-family: 'Lato', sans-serif;
    }

`;

export const Dashed = styled.div`
    margin: 16px 0;
    height: 2px;
    width: 100% - 24px;
    background-color: #BDBDBF;
`;

export const CommonDashes = styled.div`
    margin: 8px 0;
    height: 1px;
    width: 100% - 24px;
    background-color: #BDBDBF;
`;

export const Loader = styled.div`
    display: flex;
    height: 40px;
    justify-content: center;
`
    ;


export const Subtitles = styled.div`
    font-size: 20px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
    color: #5b5b5f;
    padding: 24px 0 0 0;
`;